import { History } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { PageHeader } from '@/components/blocks/page-header';
import { FeatureFeedbackCollector } from '@/components/FeedbackCollector';
import { TimesheetStatusBanners, type TimesheetStatusBannersProps } from '../status-banners/TimesheetStatusBanners';
import { TimesheetWeekNav, type TimesheetWeekNavProps } from '../week-nav/TimesheetWeekNav';

export interface TimesheetGridStickyHeaderProps {
  /** Timesheet id of the week on screen; the History action is hidden for unsaved weeks. */
  timesheetId: number;
  onOpenAuditHistory: () => void;
  statusBanners: TimesheetStatusBannersProps;
  weekNav: TimesheetWeekNavProps;
}

/** Non-scrolling top section: page header, status banners and the week toolbar. */
export function TimesheetGridStickyHeader({
  timesheetId,
  onOpenAuditHistory,
  statusBanners,
  weekNav,
}: TimesheetGridStickyHeaderProps) {
  return (
    <div className="flex-shrink-0 space-y-2 sm:space-y-3 px-0">

      {/* Page Header */}
      <div className="flex items-start gap-4 min-w-0">
        <div className="flex-1 min-w-0">
          <PageHeader
            title="Timesheets"

            size={36}
            showActions={true}
            showBreadcrumb={false}
            actions={
              timesheetId && timesheetId !== 0 ? (
                <Button
                  variant="outline"
                  size="sm"
                  onClick={onOpenAuditHistory}
                  aria-label="View Timesheet History"
                  className="gap-1.5"
                  data-tour="timesheet-history"
                >
                  <History className="h-4 w-4" />
                  <span className="hidden sm:inline">History</span>
                </Button>
              ) : undefined
            }
          />
        </div>
        <div className="flex items-center gap-4 flex-shrink-0">
          <FeatureFeedbackCollector feature="Timesheets" />
        </div>
      </div>

      <TimesheetStatusBanners {...statusBanners} />

      {/* Zone 1: Data Entry Toolbar - Redesigned Single Row Layout */}
      <div className="pb-2">
        <Card className="border-primary/20 bg-primary/5 shadow-md">
          <CardContent className="p-3 sm:p-4">
            <TimesheetWeekNav {...weekNav} />
          </CardContent>
        </Card>
      </div>

    </div>
  );
}
